export default __webpack_public_path__ + "assets/belize-flag.png";